import React, {Component} from 'react'
import {Button} from 'reactstrap';
import { IoMdOpen } from "react-icons/io";
import { BsPrinter } from "react-icons/bs";
import { MdDownloadDone } from "react-icons/md";
import SaleTimeComponent from "./SaleTimeComponent";

const storefrontUtility = require('../../utils/domain/storefrontUtility');
const dateUtil = require('../../utils/dateUtil/dateUtil');
const constants = require('../../utils/domain/constants');
const formatter = require('../../utils/formatter/formatter');
const stringUtil = require('../../utils/string/stringUtil');
const translator = require('../../utils/translator/translator');
const logger = require('../../utils/logger/logger');
const saleCalculator = require('../../utils/domain/sales/saleCalculator');
const staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility');
const staffActivities = require('../../utils/domain/staff/staffActivities');
const localizationUtils = require('../../utils/domain/localizationUtils');
const saleContextUtil = require('../../views/Order/utils/saleContextUtil');
const saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');
const staffUtility = require('../../utils/domain/staff/staffUtility');
const salesStatusUtil = require('../../utils/domain/sales/salesStatusUtil');
const businessDateUtil = require('../../utils/dateUtil/businessDateUtil');
const viewUtil = require('../../utils/view/viewUtil');
var salePrinter = require('../../views/Order/utils/salePrinter');

class SaleDetailView extends Component 
{

    render()
    {
        let sale = this.props.sale;
        
        return <div style={{marginBottom:'30px'}}>
                {this.renderToolbar(sale)}
                {this.renderOverviewSection(sale)}
                {this.renderCustomerSection(sale)}
                {this.renderPaymentSection(sale)}
                {this.renderOrderDetails(sale)}
                
            </div>
    }

    renderToolbar(sale)
    {
        let dispatchComponent = null;
        if (saleCommonUtility.isTodaysBusinessDateSale(sale) &&
            !salesStatusUtil.isSaleCompletedByDispatchStation(sale.id) &&
            saleCalculator.isSaleFullyPaid(sale) &&
            sale.saleType == constants.SaleTypeSale)
        {
            dispatchComponent = <Button className='btn-action' disabled={!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)} style={{fontSize:'1.6rem'}}
                                        onClick={()=>
                                            {
                                                logger.usage("Sale.DetailView.Dispatch", "Staff click to dispatch sale");
                                                this.onDispatchSale()
                                            }} >
                                    <MdDownloadDone style={{marginTop:'-5px'}}/>
                                </Button>;
        }

        return <div className='d-flex justify-content-between' style={{marginBottom:'20px'}}>
                    <Button className='btn-action' disabled={!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)} style={{fontSize:'1.6rem'}}
                            onClick={()=>
                            {
                                logger.usage("Sale.DetailView.Open", "Staff click to open sale");
                                this.onOpenSale()
                            }}>
                        <IoMdOpen style={{marginTop:'-5px'}}/>
                    </Button>
                    <Button className='btn-action' disabled={!staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder)} style={{fontSize:'1.6rem'}}
                            onClick={()=>
                                {
                                    logger.usage("Sale.DetailView.Print", "Staff click to print sale");
                                     this.onPrintSale()
                                }} >
                        <BsPrinter style={{marginTop:'-5px'}}/>
                    </Button>
                    {dispatchComponent}
                </div>
    }

    renderOverviewSection(sale)
    {
        let storefrontName = null;
        let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
        if (storefront != null) storefrontName = storefront.name;

        let driverName = "N/A";
        let server = "N/A";
        if (!stringUtil.isStringNullOrEmpty(sale.server))
        {
            server = sale.server;
        }

        if (!stringUtil.isStringNullOrEmpty(sale.driverId))
        {
            var staff = staffUtility.getStaffById(sale.driverId);
            if (staff != null)
                driverName = staffUtility.getStaffCompleteName(staff);
        }

        return  <div>
                    <div style={{fontWeight:'bold'}}>{translator.getLabel("overview")}</div>
                    <hr style={{marginTop:'2px', marginBottom:'2px'}}/>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("number")}</div>
                        <div>{sale.number}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("venue")}</div>
                        <div>{sale.venueCode}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("dispatch")}</div>
                        <div>{sale.dispatchType}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("storefront")}</div>
                        <div>{storefrontName}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("server")}</div>
                        <div>{server}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("driver")}</div>
                        <div>{driverName}</div>
                    </div>
                    {this.getSaleStatusComponent()}

                    <div className='d-flex justify-content-center' style={{marginTop:'10px'}}><SaleTimeComponent sale={this.props.sale}/></div>

                </div>
    }

    getSaleStatusComponent()
    {
        let sale = this.props.sale;

        if (saleCommonUtility.isSaleHoldByStaff(sale))
        {
            return <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("sale_status")}</div>
                        <div style={{background:'#585858', color:'white', paddingLeft:'5px', paddingRight:'5px'}}>{translator.getLabel("sale_status_hold_by_staff")}</div>
                    </div>
        }

        if (saleCommonUtility.isCancelled(sale))
        {
            return <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("sale_status")}</div>
                        <div style={{background:'#585858', color:'white', paddingLeft:'5px', paddingRight:'5px'}}>{translator.getLabel("sale_status_cancelled")}</div>
                    </div>
        }

        if (saleCalculator.isSaleFullyRefunded(sale))
        {
            return <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("sale_status")}</div>
                        <div style={{background:'#585858', color:'white', paddingLeft:'5px', paddingRight:'5px'}}>{translator.getLabel("sale_status_fully_refunded")}</div>
                    </div>
        }

        if (saleCalculator.calculateTotalRefunds(sale) > constants.numericThresholdValue)
        {
            return <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("sale_status")}</div>
                        <div style={{background:'#585858', color:'white', paddingLeft:'5px', paddingRight:'5px'}}>{translator.getLabel("sale_status_partially_refunded")}</div>
                    </div>
        }
   
        return null;
    }

    renderCustomerSection(sale)
    {
        let customerName = null;
        let customerPhoneNumber = null;
        let customerDeliveryAddress = null;
        

        if (!stringUtil.isStringNullOrEmpty(sale.dispatchInfo))
        {
            var dispatchInfo = JSON.parse(sale.dispatchInfo);
            customerName = dispatchInfo.customerName;
            customerPhoneNumber = dispatchInfo.customerPhoneNumber;
            customerDeliveryAddress = dispatchInfo.deliveryAddress;
        }

        if (stringUtil.isStringNullOrEmpty(customerName) &&
            stringUtil.isStringNullOrEmpty(customerPhoneNumber) &&
            stringUtil.isStringNullOrEmpty(customerDeliveryAddress)
           )
           return null;

        return <div>
                    <div style={{fontWeight:'bold', marginTop:'20px'}}>{translator.getLabel("customer")}</div>
                    <hr style={{marginTop:'2px', marginBottom:'2px'}}/>
                    <div>
                        <div>{customerName}</div>
                        <div>{customerPhoneNumber}</div>
                        <div>{customerDeliveryAddress}</div>
                    </div>
                </div>
    }

    renderPaymentSection(sale)
    {
        let paymentStatusComponent = null;
        if (saleCalculator.isSaleFullyPaid(sale))
            paymentStatusComponent = <div style={{background:'green', color:'white', 
                                                  paddingLeft:'10px', paddingRight:'10px'}}>{translator.getLabel("paid")}</div>
        else
            paymentStatusComponent = <div style={{background:'red', color:'white', 
                                                 paddingLeft:'5px', paddingRight:'5px'}}>{translator.getLabel("not_paid")}</div>

        return <div>
                    <div style={{fontWeight:'bold', marginTop:'20px'}}>{translator.getLabel("payments")}</div>
                    <hr style={{marginTop:'2px', marginBottom:'2px'}}/>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("order_price")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalOrderPrice(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("discounts")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalDiscounts(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("service_charges")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalServiceCharges(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("delivery_charges")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalDeliveryCharges(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("tips")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalTipCharges(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("sale_price")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalNetSalePrice(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("refunds")}</div>
                        <div>{formatter.convertToCurrencyFormat(saleCalculator.calculateTotalRefunds(sale))}</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div>{translator.getLabel("payment_status")}</div>
                        <div>{paymentStatusComponent}</div>
                    </div>
                </div>
    }

    renderOrderDetails(sale)
    {
        if (sale.saleItems == null || sale.saleItems.length <= 0)
            return;

        let components = [];
        sale.saleItems.forEach(saleItem =>
            {
                this.renderSaleItem(sale, components, saleItem, saleItem, 0);
            });

        let instructionComponents = null;
        if (!stringUtil.isStringNullOrEmpty(sale.instructions))
        {
            instructionComponents = <div style={{color:'var(--colors-primary)'}}>
                                        <span style={{marginRight:'5px'}}>⊛</span><span style={{fontSize:'0.8rem', marginRight:'5px'}}>{sale.instructions}</span><span>⊛</span>
                                    </div>
        }

        return <div>
                    <div style={{fontWeight:'bold', marginTop:'20px'}}>{translator.getLabel("order_details")}</div>
                    <hr style={{marginTop:'2px', marginBottom:'2px'}}/>
                    {instructionComponents}
                    <table style={{width:'100%'}}>
                        {components}
                    </table>
                </div>
    }

    renderSaleItem(sale, components, rootItem, saleItem, marginLeft)
    {
        let formattedPrice = formatter.convertToCurrencyFormat(saleItem.unitPrice * saleItem.quantity);

        var backgroundColor = null;
        var foregroundColor = null;
        if (saleItem !== rootItem && !stringUtil.isStringNullOrEmpty(saleItem.backgroundColor))
            backgroundColor = saleItem.backgroundColor;
        if (saleItem !== rootItem && !stringUtil.isStringNullOrEmpty(saleItem.foregroundColor))
            foregroundColor = saleItem.foregroundColor;

        var textDecoration = null;
        if (saleItem.isRefunded)
            textDecoration= 'line-through';

        var caption = this.formatSaleItemCaption(saleItem);
        
        if (!stringUtil.isStringNullOrEmpty(saleItem.instructions))
            caption = `${caption} ♨`

        if (saleItem.isComplimented && saleItem == rootItem)
            caption = `${caption} (✺ Complimentary ✺)`;
        else
        {
            var itemDiscount = saleCommonUtility.retrieveItemDiscount(sale, saleItem);
            if (itemDiscount != null)
            {
                caption = `${caption} (✺ Discounted / ${formatter.convertToCurrencyFormat(itemDiscount.amount)} ✺)`;
            }

            if (saleItem.isPaid)
                caption = "✅" + ` ${caption}`;
        }

        components.push( <tr>
                            <td  style={{minWidth:'30px', verticalAlign:'top'}}>
                                {saleItem == rootItem ? saleItem.quantity : ''}
                            </td>
                            <td width="99%" style={{verticalAlign:'top'}}>
                                <div style={{marginLeft:marginLeft}}>
                                    <span style={{background:backgroundColor, color:foregroundColor, padding:'2px', textDecoration:textDecoration}}>{caption}</span> 
                                </div>
                                
                            </td>
                            <td  style={{whiteSpace: "nowrap", textAlign:'right', verticalAlign:'top'}}>
                                <div style={{marginRight:'5px', textDecoration:textDecoration}}>{formattedPrice}</div>
                            </td>
                         </tr>);

        if (!stringUtil.isStringNullOrEmpty(saleItem.instructions))
        {
            components.push( <tr>
                                <td  style={{minWidth:'30px'}}/>
                                <td width="99%">
                                    <div style={{fontSize:'0.8rem', marginLeft:marginLeft, paddingLeft:'2px', color:'var(--colors-primary)'}}>
                                        {saleItem.instructions}
                                    </div> 
                                </td>
                                <td  style={{whiteSpace: "nowrap", textAlign:'right'}}/>
             </tr>);
        }

        saleItem.saleItems.forEach(subItem =>
        {
            this.renderSaleItem(sale, components, rootItem, subItem, marginLeft+20);
        })
    }

    formatSaleItemCaption(saleItem)
    {
        if (saleItem.quantity <= 1 || saleItem.unitPrice <= 0 || !localizationUtils.doPrintUnitPriceInSaleReceipt())
            return saleItem.caption;

        return `${saleItem.caption}  (@ ${formatter.convertToCurrencyFormat(saleItem.unitPrice)})`;
    }

    onOpenSale()
    {
        saleContextUtil.openSale(this.props.sale, true)
    }

    onPrintSale()
    {
        salePrinter.printSaleCustomerReceipt(this.props.sale, 1);
    }

    onDispatchSale()
    {
        try
        {
            salesStatusUtil.markSaleStatusAsCompletedByDispatchStation(this.props.sale);
            
            if (this.props.onDispatch != null)
                this.props.onDispatch();
        }
        catch(error)
        {
            let errorMessage = `${translator.getLabel("error_occurred_when_marking_sale_as_dispatch_completed")}: ${error}`;
            logger.error(errorMessage, {}, error);
            viewUtil.showErrorAlert(errorMessage);
        }
        
    }
}

export default SaleDetailView